import { __extends } from "tslib";
import { GetObjectTaggingOutput, GetObjectTaggingRequest } from "../models/models_0";
import { deserializeAws_restXmlGetObjectTaggingCommand, serializeAws_restXmlGetObjectTaggingCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetObjectTaggingCommand = /** @class */ (function (_super) {
    __extends(GetObjectTaggingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectTaggingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetObjectTaggingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectTaggingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetObjectTaggingRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetObjectTaggingOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectTaggingCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetObjectTaggingCommand(input, context);
    };
    GetObjectTaggingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetObjectTaggingCommand(output, context);
    };
    return GetObjectTaggingCommand;
}($Command));
export { GetObjectTaggingCommand };
//# sourceMappingURL=GetObjectTaggingCommand.js.map